import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {PaymentProfile} from "../types.ts";
import {useParams} from "react-router-dom";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: PaymentProfile,
        handleSubmit: (values: PaymentProfile) => void
    }) => {

    const {id: customerId} = useParams();
    const title = record?.id ? `Edit Payment Profile` : `Add Payment Profile`;

    const handleFormSubmit = async (values: PaymentProfile) => {
        // Automatically include customerId from URL params
        const payload = {
            ...values,
            customerId: customerId || values.customerId
        };
        await handleSubmit(payload);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};